<template>
	<Row
		class="archived flex-justify-space-between flex-align-center width-100 py-2"
		:class="[
			hide ? 'hide' : '',
			!showAnimation || animationEnded ? '' : isNotificationCompleted ? 'completed-animation' : 'archived-animation',
		]"
	>
		<Row class="flex-align-center">
			Notification {{ isNotificationCompleted ? 'completed' : 'archived' }}
			<SIcon v-if="isNotificationCompleted" class="ml-2" name="successfull-connection" :height="14" />
		</Row>
		<AppLoader v-if="isLoadingUnArchive" />
		<h3 v-else-if="!isNotificationCompleted" @click="unArchive" class="reg link off-white">Undo</h3>
	</Row>
</template>
<script>
import AlertService from '@/utils/alerts/alert-service';
import { mapActionsShorthand } from '@/store/utils/mappers';
import { unArchiveAlert } from '@/store/modules/alerts/actions';
export default {
	name: 'InboxUnarchiveNotification',
	props: { alert: { type: Object, required: true } },
	computed: {
		isNotificationCompleted() {
			return AlertService.isCompleted(this.alert);
		},
	},
	methods: {
		...mapActionsShorthand({ unArchiveAlert }),
		async unArchive() {
			this.isLoadingUnArchive = true;
			try {
				await this.unArchiveAlert({ id: this.alert.id });
				this.$toast.success(`Notification successfully unarchived`);
			} catch {
				this.$toast.error(`Failed to unarchive notification`);
			} finally {
				this.isLoadingUnArchive = false;
			}
		},
	},
	mounted() {
		setTimeout(() => {
			this.showAnimation = true;
		}, 10);
		setTimeout(() => {
			this.animationEnded = true;
		}, this.animationDuration);
		setTimeout(() => {
			this.hide = true;
		}, this.showItemDuration);
	},
	data() {
		return {
			showItemDuration: 3000, //MS
			animationDuration: 1000, //MS
			hide: false,
			showAnimation: false,
			animationEnded: false,
			isLoadingUnArchive: false,
		};
	},
};
</script>
<style scoped lang="scss">
.archived {
	font-size: 15px;
	color: #2c2b2c;
	transition: 0.3s;
	letter-spacing: 0px;
	background: var(--white);
	border-bottom: 1px solid #e8e8e8;
	&:hover {
		transition: 0.3s;
		background: #f7f7f7;
	}
	&.hide {
		display: none;
	}
	&.completed-animation {
		background: #87c1917b;
		transition: background-color 1000ms linear;
	}
	&.archived-animation {
		background: #e7e7e7;
		transition: background-color 1000ms linear;
	}
}
.off-white {
	font-size: 12px;
	color: #9e9e9e;
}
</style>
